module.exports = __webpack_public_path__ + "static/media/learn.d4ac809e.png";